var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._l(_vm.newsfeeds, function (newsfeed, index) {
        return newsfeed.module !== null
          ? _c("div", { key: newsfeed.id }, [
              newsfeed.module_type === "App\\Models\\Video"
                ? _c(
                    "span",
                    [
                      _c("videopost", {
                        attrs: {
                          data: newsfeed,
                          members: _vm.members,
                          administrator: _vm.administrator,
                          groups_follow: _vm.groups_follow,
                          suppliers_follow: _vm.suppliers_follow,
                        },
                        on: {
                          deleted: function ($event) {
                            return _vm.remove(index)
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              newsfeed.module_type === "App\\Models\\Resource"
                ? _c(
                    "span",
                    [
                      _c("resourcepost", {
                        attrs: {
                          data: newsfeed,
                          members: _vm.members,
                          administrator: _vm.administrator,
                          groups_follow: _vm.groups_follow,
                          suppliers_follow: _vm.suppliers_follow,
                        },
                        on: {
                          deleted: function ($event) {
                            return _vm.remove(index)
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              newsfeed.module_type === "App\\Models\\Event"
                ? _c(
                    "span",
                    [
                      _c("event", {
                        attrs: {
                          data: newsfeed,
                          members: _vm.members,
                          subscription: _vm.subscription,
                          administrator: _vm.administrator,
                          groups_follow: _vm.groups_follow,
                          suppliers_follow: _vm.suppliers_follow,
                        },
                        on: {
                          deleted: function ($event) {
                            return _vm.remove(index)
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              newsfeed.module_type === "App\\Models\\ZoomWebinar"
                ? _c(
                    "span",
                    [
                      _c("webinar", {
                        attrs: {
                          data: newsfeed,
                          members: _vm.members,
                          subscription: _vm.subscription,
                          administrator: _vm.administrator,
                          groups_follow: _vm.groups_follow,
                          suppliers_follow: _vm.suppliers_follow,
                        },
                        on: {
                          deleted: function ($event) {
                            return _vm.remove(index)
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              newsfeed.module_type === "App\\Models\\Zoom"
                ? _c(
                    "span",
                    [
                      _c("meeting", {
                        attrs: {
                          data: newsfeed,
                          members: _vm.members,
                          subscription: _vm.subscription,
                          administrator: _vm.administrator,
                          groups_follow: _vm.groups_follow,
                          suppliers_follow: _vm.suppliers_follow,
                        },
                        on: {
                          deleted: function ($event) {
                            return _vm.remove(index)
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              newsfeed.module_type === "App\\Models\\Post"
                ? _c(
                    "span",
                    [
                      _c("post", {
                        attrs: {
                          data: newsfeed,
                          members: _vm.members,
                          administrator: _vm.administrator,
                          groups_follow: _vm.groups_follow,
                          suppliers_follow: _vm.suppliers_follow,
                          section: _vm.section,
                          questions_enabled: _vm.questions_enabled,
                        },
                        on: {
                          deleted: function ($event) {
                            return _vm.remove(index)
                          },
                          sortpost: function ($event) {
                            return _vm.sortposts()
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              newsfeed.module_type === "App\\Models\\Job"
                ? _c(
                    "span",
                    [
                      _c("job", {
                        attrs: {
                          data: newsfeed,
                          members: _vm.members,
                          administrator: _vm.administrator,
                          groups_follow: _vm.groups_follow,
                          suppliers_follow: _vm.suppliers_follow,
                        },
                        on: {
                          deleted: function ($event) {
                            return _vm.remove(index)
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              newsfeed.module_type === "App\\Models\\Product"
                ? _c(
                    "span",
                    [
                      _c("product", {
                        attrs: {
                          data: newsfeed,
                          members: _vm.members,
                          administrator: _vm.administrator,
                          groups_follow: _vm.groups_follow,
                          suppliers_follow: _vm.suppliers_follow,
                        },
                        on: {
                          deleted: function ($event) {
                            return _vm.remove(index)
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              newsfeed.module_type === "App\\Models\\Stack\\Question"
                ? _c(
                    "span",
                    [
                      _c("question", {
                        attrs: {
                          data: newsfeed,
                          members: _vm.members,
                          administrator: _vm.administrator,
                        },
                        on: {
                          deleted: function ($event) {
                            return _vm.remove(index)
                          },
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ])
          : _vm._e()
      }),
      _vm._v(" "),
      _c("infinite-loading", { on: { infinite: _vm.infiniteHandler } }, [
        _c("div", { attrs: { slot: "no-more" }, slot: "no-more" }),
        _vm._v(" "),
        _c("div", { attrs: { slot: "no-results" }, slot: "no-results" }),
      ]),
      _vm._v(" "),
      _vm.newsfeeds.length === 0
        ? _c("div", [
            _c("div", { staticClass: "card bg-outline-gray" }, [
              _c("div", { staticClass: "card-header" }, [
                _c("h4", { staticClass: "card-title gray" }, [
                  _vm._v(_vm._s(_vm.__("globals.no_posts_header"))),
                ]),
                _vm._v(" "),
                _vm._m(0),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "card-body" }, [
                _c("span", { staticClass: "gray" }, [
                  _vm._v(_vm._s(_vm.__("globals.no_post_content"))),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("a", { attrs: { href: "/member/help" } }, [
                    _c(
                      "button",
                      { staticClass: "btn btn-outline-light mt-1" },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.__("globals.help_button")) +
                            "\n                        "
                        ),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _vm._m(1),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("span", { domProps: { textContent: _vm._s(_vm.newsfeeds.links) } }),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "heading-elements" }, [
      _c("ul", { staticClass: "list-inline mb-0" }, [
        _c("li", {}, [
          _c("a", { attrs: { "data-action": "close" } }, [
            _c("i", { staticClass: "feather icon-x" }),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ml-auto" }, [
      _c("img", {
        staticStyle: { float: "right", "margin-top": "-40px" },
        attrs: { src: "/images/annie.png", width: "50px" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }